import {
  AkaAdviceCheckboxes,
  AkaCriticalIllnessAdviceFormValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import {
  CoverageNeed,
  ProductCoverageName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";
import {
  isAllowed,
  isDisplayedAndChecked,
} from "Store/akaAdvice/interfaces/getters";
import { getAdviceValueOrMinPayout } from "./utils";

export const mapToIndividualCriticalIllnessFormValues = (
  isAdvisor: boolean,
  need: CoverageNeed,
): Partial<AkaCriticalIllnessAdviceFormValues> => {
  const criticalIllnessCheckbox = isDisplayedAndChecked(
    need,
    ProductCoverageName.CRITICAL_ILLNESS,
  );
  const criticalIllnessInsuredSumCheckbox = isAllowed(
    need,
    ProductCoverageName.CRITICAL_ILLNESS,
  );

  return {
    [AkaAdviceCheckboxes.CRITICAL_ILLNESS_CHECKBOX]: criticalIllnessCheckbox,

    akaCriticalIllnessCoverageAmountCheckbox: false,

    criticalIllnessInsuredSumCheckbox,
    criticalIllnessInsuredSumSlider: getAdviceValueOrMinPayout(
      need,
      ProductCoverageName.CRITICAL_ILLNESS,
      isAdvisor,
    ),
    criticalIllnessAdviceComment: undefined,
  };
};
